import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import {AnalyticsService} from '../../shared/analytics.service';
import {HttpError} from '../../shared/api.service';
import {AppStateService} from '../../shared/app-state.service';
import {AuthService} from '../../shared/auth.service';
import {ClientApiService} from '../client-api.service';

@Component({
  selector: 'talent-pool-card',
  templateUrl: './talent-pool-card.component.html',
  styleUrls: ['./talent-pool-card.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TalentPoolCardComponent implements OnInit, OnChanges {

  @Input() submittal: Submittal;
  @Input() favorites: string[];
  @Input() small = false;

  @Output('favorite') onFavorite = new EventEmitter<boolean>();
  @Output() identify = new EventEmitter<Function | null>();

  favorite = false;
  saving = false;
  profileName: string;
  user$ = this.Auth.user$;
  masquerading$ = this.Auth.masquerading$;

  constructor(private Analytics: AnalyticsService,
              private Api: ClientApiService,
              private AppState: AppStateService,
              private Auth: AuthService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['submittal'] && this.submittal && this.submittal.profile) {
      // Unescape possibly HTML-encoded name
      const elem = document.createElement('span');
      elem.innerHTML = this.submittal.profile.profileName;
      this.profileName = elem.textContent;
    }
    if ((changes['favorites'] || changes['submittal']) && this.favorites && this.submittal.personId) {
      this.favorite = this.favorites.includes(this.submittal.personId);
    }
  }

  isFavorite(): boolean {
    return this.favorite;
  }

  toggleFavorite(event?: Event): Promise<void> {
    if (event) event.stopPropagation();
    if (this.saving || this.masquerading$.getValue()) {
      return;
    }
    if (!this.Auth.isFullyAuthenticated()) {
      this.identify.emit(() => this.toggleFavorite());
      return;
    }
    this.favorite = !this.favorite;
    this.Analytics.trackEvent(`Talent Pools: ${this.favorite ? 'Favorite' : 'Unfavorite'} clicked`, {category: 'Action'});
    this.saving = true;
    return ((this.favorite ? this.Api.addFavorite : this.Api.removeFavorite)
      .call(this.Api, this.submittal.personId) as Observable<void>)
      .toPromise()
      .then(() => {
        this.onFavorite.next(this.favorite);
        this.Analytics.trackEvent(`Talent Pools: ${this.favorite ? 'Favorite' : 'Unfavorite'} succeeded`, {category: 'Event'});
        this.saving = false;
      }, (err: HttpError) => {
        console.error('Failed to update favorites.', err);
        this.Analytics.trackEvent('Talent Pools: Favorite/unfavorite failed', {category: 'Error'});
        // TODO
        // this.onError.next(this.Translate.instant('talent-pool.favorite-save-error', {error: err.code}));
        this.favorite = !this.favorite;
        this.saving = false;
      });
  }

  showIdentification(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.identify.emit();
  }
}
